import React from 'react';

const AnomalyDistributionChart = ({ data }) => {
    if (!data || data.length === 0) {
        return (
            <div className="bob-distribution-chart">
                <h4>Anomaly Distribution</h4>
                <p style={{ color: 'rgba(255, 255, 255, 0.5)' }}>No data available</p>
            </div>
        );
    }

    const totalMinutes = data.reduce((sum, item) => sum + item.minutes, 0);
    const maxMinutes = Math.max(...data.map(item => item.minutes));

    const formatMinutes = (minutes) => {
        if (minutes < 60) return `${minutes} min`;
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        if (mins === 0) return `${hours}h`;
        return `${hours}h ${mins}m`;
    };

    return (
        <div className="bob-distribution-chart">
            <h4>Time Distribution by Anomaly Level</h4>
            <div className="bob-distribution-bars">
                {data.map((item, index) => (
                    <div key={index} className="bob-distribution-item">
                        <span className="bob-distribution-label">{item.range}</span>
                        <div className="bob-distribution-bar-container">
                            <div
                                className="bob-distribution-bar"
                                style={{
                                    width: maxMinutes > 0 ? `${(item.minutes / maxMinutes) * 100}%` : '0%',
                                    backgroundColor: item.color
                                }}
                            />
                        </div>
                        <span className="bob-distribution-value">
                            {formatMinutes(item.minutes)}
                        </span>
                    </div>
                ))}
            </div>
            <div style={{
                marginTop: '16px',
                fontSize: '13px',
                color: 'rgba(255, 255, 255, 0.5)',
                textAlign: 'right'
            }}>
                Total: {formatMinutes(totalMinutes)}
            </div>
        </div>
    );
};

export default AnomalyDistributionChart;
